export default "__VITE_ASSET__329bdad5__"